
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0.875 0.875 12.25 12.25">
  <path
    d="M9.71556 9.09694L9.09694 9.71556L7 7.61862L4.90306 9.71556L4.28444 9.09694L6.38138 7L4.28444 4.90306L4.90306 4.28444L7 6.38138L9.09694 4.28444L9.71556 4.90306L7.61862 7L9.71556 9.09694ZM7 0.875C3.61725 0.875 0.875 3.61725 0.875 7C0.875 10.3827 3.61725 13.125 7 13.125C10.3827 13.125 13.125 10.3827 13.125 7C13.125 3.61725 10.3827 0.875 7 0.875Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'CloseCircleFilled',
    }) as DefineComponent
    </script>
    